import { useMemo } from 'react';

import { useCageController_FishTypes } from '@/services/hooks';

import { mapFishTypesToDomain } from './mappers';
import type { UseGetFishTypesResult } from './types';

export const useGetFishTypes = (): UseGetFishTypesResult => {
    const fishTypesQuery = useCageController_FishTypes();

    const fishTypes = useMemo(() => {
        if (!fishTypesQuery.data?.data) {
            return [];
        }
        return mapFishTypesToDomain(fishTypesQuery.data.data);
    }, [fishTypesQuery.data?.data]);

    return {
        ...fishTypesQuery,
        isLoading: fishTypesQuery.isPending,
        data: fishTypes,
    };
};
